// The desktop row is flex-nowrap, so these are hard floors: below their sum the
// row overflows and the conversation list clips off the left edge.
export const CONVERSATION_PANE_MIN_WIDTH = 395
export const MESSAGE_PANE_MIN_WIDTH = 450
export const DETAILS_PANE_MIN_WIDTH = 300

// The mobile layout takes over below this, so the desktop one is never rendered
// at a width it cannot fit.
export const MIN_DESKTOP_WIDTH = CONVERSATION_PANE_MIN_WIDTH + MESSAGE_PANE_MIN_WIDTH

// Where the details pane opens: room to spare, not a fitting constraint. The
// comparison is exclusive, matching the width this has always opened above.
export const DETAILS_PANE_BREAKPOINT = 1400
